import React, { useCallback } from "react";

import styles from "./styles.module.css";

type DefaultListCheckboxProps = {
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
  readonly disabled?: boolean;
};

export default function DefaultListCheckbox({
  checked,
  onChange,
  disabled = false,
}: DefaultListCheckboxProps) {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.checked);
    },
    [onChange]
  );

  return (
    <label className={styles.checkboxLabel}>
      <input
        type="checkbox"
        className={styles.checkboxInput}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <span className={styles.checkboxBox} aria-hidden="true">
        {checked && (
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 3L4.5 8.5L2 6"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      Default List
    </label>
  );
}
